var _defs, _line, _line2, _line3, _line4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntellix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770.71 705.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:20px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.16,
    x2: 162.16,
    y2: 705.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 254.31,
    y1: 705.54,
    x2: 254.31,
    y2: 29.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.71,
    y1: 67.1,
    x2: 723.51,
    y2: 67.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 199.81,
    x2: 569.05,
    y2: 199.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1221.28,421.28q-32.71-61.77-90.92-91.87T946.5,299.32H774.28V354.2H949q92.44,0,135.65,24.45t64.31,76q21.1,51.54,21.11,123.12T1147,696.65q-23.12,47.29-66.72,69.45T951,788.24H855.37v0l-81.09.49v60.07H957.74q117.62,0,177.44-35.75t89.32-96.83Q1254,655.12,1254,571.93,1254,483.07,1221.28,421.28Z",
    transform: "translate(-483.29 -191.94)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellix);
export default __webpack_public_path__ + "static/media/intellix.db1fef61b9d6ff961163d0f52f8284cb.svg";
export { ForwardRef as ReactComponent };